import { adminCall, adminGet } from './adminCall';

export async function adminListPackages() {
  const result = await adminGet('/api/admin/packages');
  return result.packages || [];
}

export async function adminSavePackage({ packageId, packageData }) {
  return adminCall('/api/admin/packages', { packageId, packageData });
}

export async function adminDeletePackage({ packageId, forceDeactivate = false }) {
  return adminCall(`/api/admin/packages/${encodeURIComponent(packageId)}/delete`, {
    forceDeactivate,
  });
}

export async function adminGetCompanyByOwnerId(ownerId) {
  const params = new URLSearchParams();
  params.set('ownerId', ownerId);
  const result = await adminGet(`/api/admin/companies?${params.toString()}`);
  return result.company || null;
}

export async function adminGetCompany(companyId) {
  const result = await adminGet(`/api/admin/companies/${encodeURIComponent(companyId)}`);
  return result.company || null;
}
